import { ChangeDetectionStrategy, Component, inject, input, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { IDependentItem } from '../../models/idependent-item';
import { IScopingItemGroupMapping } from '../../models/iscoping-item-group-mapping';
import { ScopingItemsSharedService } from '../../scoping-items-shared-service';
import { ItemManagementBrokerService } from '../../services/item-management-broker.service';

@Component({
  selector: 'app-drag-drop-dependent-item',
  templateUrl: './drag-drop-dependent-item.component.html',
  styleUrls: ['./drag-drop-dependent-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    ComboBoxComponent,
    FormsModule,
    NumericTextBoxComponent,
  ],
})
export class DragDropDependentItemComponent implements OnInit {
  private scopingItemsSharedService = inject(ScopingItemsSharedService);
  private broker = inject(ItemManagementBrokerService);

  readonly dependentItem = input<IDependentItem>(undefined);
  readonly parent = input<IScopingItemGroupMapping>(undefined);
  readonly removeEvent = output<IDependentItem>();

  public icons = kendoIcons;
  public projectSubTypes = [];
  public selectedProjectSubType;

  ngOnInit() {
    this.projectSubTypes = this.scopingItemsSharedService.IProjectSubTypeDtos.filter(s => s.ProjectTypeId === 1);
    if (this.dependentItem().ProjectSubTypeId != null) {
      this.selectedProjectSubType = this.projectSubTypes.find(s => s.ProjectSubTypeId === this.dependentItem().ProjectSubTypeId);
    }
  }

  public onChange(event: any) {
    const dependentItem = this.dependentItem();
    if (event === null) {
      dependentItem.Quantity = null;
    }
    else if (event === undefined) {
      dependentItem.ProjectSubTypeId = null;
    }
    else if (event.ProjectSubTypeId) {
      dependentItem.ProjectSubTypeId = event.ProjectSubTypeId;
    } else {
      dependentItem.Quantity = event;
    }

    dependentItem.IsModified = true;

    let scopingItemId = this.parent().ScopingItemId;

    this.broker.UpdateDependentItemEvent.next({ dependentItem: dependentItem, destScopingItemId: scopingItemId });
  }

  public removeWell(dependentItem: IDependentItem) {
    this.removeEvent.emit(dependentItem);
  }
}